import { bgLastUpdatedToUk } from '@lib/utils/stringHelper';
import { StyledGapContainer } from '@views/auth/signup/styles';

import {
  StyledButton,
  StyledDate,
  StyledHeader,
  StyledParagraph,
  StyledStatusUk,
  StyledUkBox,
} from '../../statusBoxStyles';

type InvitedBoxUnavailableUkProps = {
  isMobileDevice: boolean;
  bg_last_updated: string | null;
  handleAvailable: () => void;
  is_archived: boolean | null;
};
export const InvitedBoxUnavailableUk = ({
  isMobileDevice,
  bg_last_updated,
  handleAvailable,
  is_archived,
}: InvitedBoxUnavailableUkProps) => {
  const formattedDate = bgLastUpdatedToUk(bg_last_updated);
  return (
    <StyledUkBox isMobileDevice={isMobileDevice}>
      <div className='content'>
        <StyledGapContainer gap={16}>
          <StyledHeader>
            <StyledStatusUk>Status: Unavailable</StyledStatusUk>
            <StyledDate>{formattedDate}</StyledDate>
          </StyledHeader>
          <StyledParagraph>
            Thank you for responding! Telling us you are “Unavailable” will
            never affect your ability to book future work. We appreciate the
            response!
          </StyledParagraph>
          <StyledButton
            disabled={is_archived}
            onClick={handleAvailable}
            width={238}
          >
            Change my status to available
          </StyledButton>
        </StyledGapContainer>
      </div>
    </StyledUkBox>
  );
};
